<template>
    <div class="is-flex is-justify-content-space-between is-align-items-center">
        <Input
            inputId="editAmount"
            placeholder="$200.000"
            rules="required|positive-money|max:13"
            inputClasses="is-small"
            v-money="configMoney"
            v-model="amountEdit"
        />
        <b-button type="is-flow" size="is-small" class="ml-4 mr-2" @click="onUpdateManualAmount">Actualizar</b-button>
        <b-button type="is-flow" size="is-small" outlined @click="onCancelManualAmount">Cancelar</b-button>
    </div>
</template>

<script>
import Input from "@/components/inputs/Input";
import { configMoney, Money } from "@/utils/currency";

export default {
    name: "AmountEdit",
    components: {
        Input,
    },
    props: {
        amount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            configMoney: configMoney,
            amountEdit: this.amount,
        }
    },
    methods: {
        onUpdateManualAmount: function(){this.$emit('onUpdateManualAmount', parseInt(this.amountEdit.replace("$ ", "").replace(/\./g, '')))},
        onCancelManualAmount: function(){this.$emit('onCancelManualAmount')},
    },
    directives: { money: Money },
};
</script>